export const BRAND_NAME = 'Andino Express';
export const BRAND_TAGLINE = 'La vitrina digital de los emprendedores colombianos';

/** Datos de contacto institucional (Sobre nosotros, pie de página, formularios). */
export const CONTACT_EMAIL_PUBLIC = 'surandinocomercializadora@gmail.com';
export const CONTACT_PHONE_DISPLAY = '321 231 6718';
export const CONTACT_PHONE_E164 = '+573212316718';
export const CONTACT_ADDRESS_PUBLIC = 'Pasto, Nariño, Colombia';
